// extracted by mini-css-extract-plugin
var _1 = "Anchor-qGk0d";
var _2 = "Paragraph-lBFKi";
export { _1 as "Anchor", _2 as "Paragraph" }
